const returnApiHeaders = type => {
  if (JSON.parse(localStorage.getItem('okta-token-storage')) !== null) {
    const tokenObject = JSON.parse(localStorage.getItem('okta-token-storage'));
    const AuthStr = 'Bearer '.concat(tokenObject.accessToken.accessToken);
    const getHeaders = {
      'Content-Type': 'application/json',
      Authorization: AuthStr,
    };

    if (type === 'GET') {
      return getHeaders;
    }
  }
};

export default returnApiHeaders;
